import { useState, useEffect, useRef, lazy } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, ButtonToolbar } from 'reactstrap';
import Dialog from '../../componentes/dialog';
import Button from '../../componentes/button';
import LoadingContainer from '../../componentes/loading-container';
import ColaboradorList from './select-list';
import errorHandler from '../../utils/error-handler';
import http from '../../services/httpService';
import { capitalizeFirstLetter } from '../../utils/string';
import useAuth from 'src/hooks/useAuth';

const ReactQuillComponent = lazy(() => import('src/componentes/quill'));
const colors = [
  '#000000',
  '#e60000',
  '#ff9900',
  '#ffff00',
  '#008a00',
  '#0066cc',
  '#9933ff',
  '#ffffff',
  '#facccc',
  '#ffebcc',
  '#ffffcc',
  '#cce8cc',
  '#cce0f5',
  '#ebd6ff',
  '#bbbbbb',
  '#f06666',
  '#ffc266',
  '#ffff66',
  '#66b966',
  '#66a3e0',
  '#c285ff',
  '#888888',
  '#a10000',
  '#b26b00',
  '#b2b200',
  '#006100',
  '#0047b2',
  '#6b24b2',
  '#444444',
  '#5c0000',
  '#663d00',
  '#666600',
  '#003700',
  '#002966',
  '#3d1466',
];

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: colors }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'list',
  'bullet',
  'indent',
  'link',
];

function EmailColaboradores({ ...rest }) {
  const [conteudo, setConteudo] = useState('');
  const [colaboradores, setColaboradores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dialogRef = useRef();

  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleClose = () => {
    dialogRef.current?.close();
  };

  useEffect(() => {
    http
      .post('ConfiguracaoSistema/ObterMensagemEmailColaboradorNovo', {})
      .then((response) => {
        const defaultMessage = intl.formatMessage({ id: 'bemVindoSistema' });
        setConteudo(response.data || defaultMessage);
      })
      .catch((error) => {
        errorHandler(error);
        handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [intl]);

  const isValid = () => {
    return (
      !isLoading &&
      conteudo.trim().length > 0 &&
      colaboradores &&
      colaboradores.length > 0
    );
  };

  const handleSendEmail = () => {
    if (!isValid()) return;

    setIsLoading(true);
    http
      .post('Colaborador/EnviarEmailColaboradoresNovos', {
        conteudo,
        colaboradores,
      })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        errorHandler(error);
        handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const actions = [
    <ButtonToolbar key="toolbar-img">
      <Button
        onClick={handleClose}
        className="pull-left"
        leftIcon="close"
        color="secondary"
      >
        {intl.formatMessage({ id: 'label.fechar' })}
      </Button>
      <Button
        disabled={!isValid()}
        onClick={handleSendEmail}
        className="ml-2"
        leftIcon="email"
        type="primary"
      >
        {intl.formatMessage({ id: 'enviarEmail' })}
      </Button>
    </ButtonToolbar>,
  ];

  return (
    <Dialog
      ref={dialogRef}
      title={capitalizeFirstLetter(resources.colaboradores)}
      width={900}
      height={750}
      actions={actions}
      padContent
      respeitarAltura
      onRequestClose={handleClose}
      {...rest}
    >
      <div style={{ position: 'relative' }}>
        <LoadingContainer isLoading={isLoading}>
          <Row className="mb-3">
            <Col md={12}>
              <ReactQuillComponent
                style={{ minHeight: 200 }}
                value={conteudo}
                theme="snow"
                formats={formats}
                modules={modules}
                onChange={(e) => setConteudo(e)}
              />
            </Col>
          </Row>
          <ColaboradorList
            filtroInterno={{ filtrarEmailNotNull: true }}
            pageSize={10000}
            forcarPageSize
            showPage={true}
            somenteAtivos={true}
            model={{
              value: colaboradores,
              requestChange: setColaboradores,
            }}
          />
        </LoadingContainer>
      </div>
    </Dialog>
  );
}

export default EmailColaboradores;
